module.exports = __webpack_public_path__ + "img/video_hover_icon.f127e4e1.svg";